export const GET_ORDINANCE_REVISION =
  'GET_ORDINANCE_REVISION/get_ordinance_revision';

export const GET_FORMDATA_ORDINANCE_REVISION_RPT =
  'GET_FORMDATA_ORDINANCE_REVISION_RPT/get_ordinance_revision';